<template>
  <v-card>
    <v-container>
      <v-layout wrap>
        <v-flex
          xs12
          sm6
        >
          <v-select
            v-model="$currentUser.preferences.currencyFormat"
            label="Currency format"
            :items="allCurrencyFormats"
          />
        </v-flex>

        <v-flex
          xs12
          sm6
        >
          <v-select
            v-model="$currentUser.preferences.dateFormat"
            label="Date format"
            :items="allDateFormats"
          />
        </v-flex>
      </v-layout>
    </v-container>

    <v-card-actions>
      <v-btn
        text
        :disabled="$currentUser.loading || $currentUser.saving"
        @click="cancel()"
      >
        Cancel
      </v-btn>

      <v-spacer />

      <v-btn
        color="primary"
        text
        :loading="$currentUser.saving"
        :disabled="$currentUser.loading || $currentUser.saving"
        @click="save()"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      currencyFormatStrings: [
        [0, '.', ','],
        [0, ',', '.'],
        [0, ' ', ','],
        [0, ' ', '.']
      ],
      dateFormatStrings: [
        'D MMM YYYY',
        'Do MMMM YYYY'
      ]
    }
  },
  computed: {
    ...mapGetters('user', [ 'preferences' ]),
    allCurrencyFormats () {
      let amount = 78450
      let fmtCurrency = Vue.filter('fmtCurrency')

      return this.currencyFormatStrings.map(fmt => {
        return { text: fmtCurrency(amount, { currency: '€', format: fmt }), value: fmt }
      })
    },
    allDateFormats () {
      let date = new Date()

      return this.dateFormatStrings.map(fmt => {
        return { text: moment(date).format(fmt), value: fmt }
      })
    }
  },
  mounted () {
    this.cancel()
  },
  methods: {
    save () {
      this.$currentUser.save()
    },
    cancel () {
      this.$currentUser.reset()
    }
  }
}
</script>
